export const getIsOwnerTrust = (
  owner: string,
  ownerOptions: { label: string; options: { label: string; value: string }[] }[],
) => {
  const trustOptions = ownerOptions.find(({ label }) => label === 'Trusts')?.options;

  return !!trustOptions?.some(({ value }) => value === owner);
};
